import RegisterCard from "../components/RegisterCard";

export default function Register() {
  return (
    <div className="register-page">
      <RegisterCard />
    </div>
  );
}
